import lambda from 'common/lambda';
import { client } from 'graphql/client';
import {
  DeleteFileDocument,
  DeleteChatroomDocument,
  DeleteChatroomMemberDocument,
  DeleteMessageDocument,
  GetAllMessageDocument,
  GetChatroomByKindDocument,
  GetChatroomFileListDocument,
  GetChatroomMemberDocument,
  GetChatroomReadStatusDocument,
  GetMessageDocument,
  GetNoticeDocument,
  RegisterChatroomDocument,
  RegisterChatroomMemberDocument,
  RegisterFileDocument,
  RegisterFileMessageDocument,
  RegisterMessageDocument,
  RegisterNoticeDocument,
  UpdateChatroomDocument,
  UpdateChatroomReadStatusDocument,
  UpdateMessageDocument,
  UpdateNoticeDocument,
} from 'graphql/query';

export function getAllMessageAPI({ params }: any) {
  return client.query(GetAllMessageDocument, params).toPromise();
}
export function getChatroomMemberAPI({ params }: any) {
  return client.query(GetChatroomMemberDocument, params).toPromise();
}
export function registerMessageAPI({ params }: any) {
  return client.mutation(RegisterMessageDocument, params).toPromise();
}
export function updateMessageAPI({ params }: any) {
  return client.mutation(UpdateMessageDocument, params).toPromise();
}
export function deleteMessageAPI({ params }: any) {
  return client.mutation(DeleteMessageDocument, params).toPromise();
}
export function registerChatroomAPI({ params }: any) {
  return client.mutation(RegisterChatroomDocument, params).toPromise();
}
export function registerChatroomMemberAPI({ params }: any) {
  return client.mutation(RegisterChatroomMemberDocument, params).toPromise();
}
export function updateChatroomAPI({ params }: any) {
  return client.mutation(UpdateChatroomDocument, params).toPromise();
}
export function deleteChatroomMemberAPI({ params }: any) {
  return client.mutation(DeleteChatroomMemberDocument, params).toPromise();
}
export function deleteChatroomAPI({ params }: any) {
  return client.mutation(DeleteChatroomDocument, params).toPromise();
}
export function registerFileMessageAPI({ params }: any) {
  return client.mutation(RegisterFileMessageDocument, params).toPromise();
}
export function registerFileAPI({ params }: any) {
  return client.mutation(RegisterFileDocument, params).toPromise();
}
export function registerNoticeAPI({ params }: any) {
  return client.mutation(RegisterNoticeDocument, params).toPromise();
}
export function getNoticeAPI({ params }: any) {
  return client.query(GetNoticeDocument, params).toPromise();
}
export function getChatroomFileListAPI({ params }: any) {
  return client.query(GetChatroomFileListDocument, params).toPromise();
}
export function getChatroomByKindAPI({ params }: any) {
  return client.query(GetChatroomByKindDocument, params).toPromise();
}
export function getChatroomReadStatusAPI({ params }: any) {
  return client.query(GetChatroomReadStatusDocument, params).toPromise();
}
export function updateChatroomReadStatusAPI({ params }: any) {
  return client.mutation(UpdateChatroomReadStatusDocument, params).toPromise();
}
export function updateNoticeAPI({ params }: any) {
  return client.mutation(UpdateNoticeDocument, params).toPromise();
}

export function getMessageAPI({ params }: any) {
  return client.query(GetMessageDocument, params).toPromise();
}
export function deleteFileAPI({ params }: any) {
  return client.mutation(DeleteFileDocument, params).toPromise();
}

export const exportChatMessageAPI = (params: any) => lambda.post('/exportChatMessage', params);
